<div>
  <mat-dialog-content>
    <h3 style="text-align: center; padding: 10px">{{ data.message }}</h3>
    <mat-progress-bar class="spinner" mode="indeterminate"></mat-progress-bar>
  </mat-dialog-content>
</div>
